import React from 'react'
import styles from './Retry.module.css'
import retryIcon from './retry.svg'
export const Retry: React.FC = () => {
  return (
    <div className={styles.retry}>
      <img src={retryIcon} alt="" />
      <div>点击重新加载</div>
    </div>
  )
}